export function mapPropsToData(children) {
    // Coerces the react children into an array. We need
    // to do this because if there is only one child in
    // of the component, it is populated as a single object
    // and not as an array.
    var tableRows = (Array.isArray(children) ? children : [children]).map(function (slide) { return slide === null || slide === void 0 ? void 0 : slide.props; }).filter(function (slide) { return !!slide; });
    return {
        headerCells: generateHeaderCells(tableRows),
        dataRows: generateDataRowsAndCells(tableRows),
    };
}
function generateHeaderCells(tableRows) {
    var headerCells = [];
    var tableColumns = Array.isArray(tableRows[0].children) ? tableRows[0].children : [tableRows[0].children];
    for (var _i = 0, tableColumns_1 = tableColumns; _i < tableColumns_1.length; _i++) {
        var tableColumn = tableColumns_1[_i];
        if (tableColumn && !tableColumn.props.hidden)
            headerCells.push({ id: tableColumn.props.id, label: tableColumn.props.label, sortable: tableColumn.props.sortable, width: tableColumn.props.width, locked: tableColumn.props.locked });
    }
    return headerCells;
}
function generateDataRowsAndCells(tableRows) {
    var dataRows = [];
    for (var _i = 0, tableRows_1 = tableRows; _i < tableRows_1.length; _i++) {
        var tableRow = tableRows_1[_i];
        var dataRow = {
            dataCells: [],
            isLoading: tableRow.isLoading,
            configCell: tableRow.configCell,
            id: tableRow.id,
        };
        var tableColumns = Array.isArray(tableRow.children) ? tableRow.children : [tableRow.children];
        for (var _a = 0, tableColumns_2 = tableColumns; _a < tableColumns_2.length; _a++) {
            var tableColumn = tableColumns_2[_a];
            if (!!tableColumn && !tableColumn.props.hidden)
                dataRow.dataCells.push({
                    id: tableColumn.props.id,
                    label: tableColumn.props.label,
                    textAlign: tableColumn.props.textAlign,
                    flexAdjust: tableColumn.props.flexAdjust,
                    width: tableColumn.props.width,
                    onClick: tableColumn.props.onClick,
                    children: !!tableColumn.props.children ? tableColumn.props.children : tableColumn.props.emptyText,
                    locked: tableColumn.props.locked,
                });
        }
        dataRows.push(dataRow);
    }
    return dataRows;
}
